import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as FleetActionModel from './Models/FleetActionModel';
import * as FleetModule from 'Modules/FleetModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import { reset } from 'redux-form';
import { history } from 'HelperFunctions/root';
import * as Dictionary from 'Models/Dictionary';
import * as ErrorActions from "Redux/Actions/ErrorActions";
import {EnumTypes as ErrorEnumType} from "Models/EnumTypes/ErrorEnumTypes";
import i18n from "Translations/_i18n";
import {RootState} from "Redux/Reducers/_RootReducer";
import {IManageFleetFormValues} from "Models/FleetModel";
import {START_FROM} from "../../constants";

function createFleet(newFleetData: FleetModule.Types.AddFleetRequest) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        await FleetModule.Connector.addNewFleet(newFleetData);
        dispatch(createFleetSuccess());
        dispatch(reset('AddFleet'));
        dispatch(resetFleetCars());
        dispatch(ViewManagementModule.Actions.hideLoader());
        history.push(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.FLEET));
    };
}
function getUsersFleet(params?: URLSearchParams) {
    return async (dispatch, getState: () => RootState) => {
        if (params) {
          dispatch(setParams(params))
        }
        const { fleetStore } = getState()
        dispatch(ViewManagementModule.Actions.showLoader());
        const getUserFleetResponse = await FleetModule.Connector.getUserFleets(fleetStore.params);

        const { data: fleetsData} = getUserFleetResponse

        if (Number(fleetStore.params.get('first')) > 0) {
          const oldFleets = fleetStore.fleets.results

          fleetsData.results = oldFleets.concat(fleetsData.results)
        }

        dispatch(getUsersFleetSuccess(fleetsData));
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}

function resetFleetFilteredData() {
    return dispatch => {
        dispatch(resetFleetFilteredDataSuccess());
    }
}

function resetFleetFilteredDataSuccess(): FleetActionModel.ResetFleetFilteredData {
    return {
        type: ActionTypes.FLEET.RESET_FLEET_FILTERED_DATA
    }
}

function updateFleet(fleetId: number, fleetData: FleetModule.Types.AddFleetRequest) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        const updateFleetResponse = await FleetModule.Connector.updateFleet(fleetId, fleetData);
        dispatch(updateFleetCarsSuccess(updateFleetResponse.data));
        dispatch(setActiveFleet(updateFleetResponse.data.fleets));
        dispatch(ViewManagementModule.Actions.hideLoader());
        history.push(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.FLEET));
    };
}

function deleteCarFromFleet(fleetId: number, carId: number) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        await FleetModule.Connector.deleteCarFromFleet(fleetId, carId);
        dispatch(deleteCarFromFleetSuccess());
        dispatch(getFleetById(fleetId));
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}

function deleteFleet(fleetId: number) {
    return async (dispatch, getState: () => RootState) => {
        dispatch(ViewManagementModule.Actions.showLoader());
        try {
            await FleetModule.Connector.deleteFleet(fleetId);
            dispatch(deleteFleetSuccess());
            dispatch(ErrorActions.setNewsForMoment({
                type: ErrorEnumType.NewsType.SUCCESS,
                message: i18n.t('dictionary:FLEET_REMOVE_SUCCESS')
            }));
        } catch (e) {
            dispatch(ErrorActions.setNewsForMoment({
                type: ErrorEnumType.NewsType.ERROR,
                message: i18n.t(`errors:${e.response.data.errorSubcode}`, { fleetId })
            }));
        }

        const { params } = getState().fleetStore

        const newParams = new URLSearchParams(params)

        newParams.set('first', `${START_FROM}`)

        await dispatch(getUsersFleet(newParams));
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}
function setActiveFleet(activeFleet: FleetModule.Types.CarFleetDto): FleetActionModel.SetActiveFleet {
    return {
        type: ActionTypes.FLEET.SET_ACTIVE_FLEET,
        payload: {
            activeFleet
        }
    };
}
function setActiveRowId(activeFleetRowId: number): FleetActionModel.SetActiveRowId {
    return {
        type: ActionTypes.FLEET.SET_ACTIVE_ROW_ID,
        payload: {
            activeFleetRowId
        }
    };
}
function manageFleetCars(type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto): FleetActionModel.ManageFleetCars {
    return {
        type: ActionTypes.FLEET.MANAGE_FLEET_CARS,
        payload: {
            type,
            car
        }
    };
}

function getFleetById(fleetId: number) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        const response = await FleetModule.Connector.getFleetById(fleetId);
        dispatch(setActiveFleet(response.data.fleets));
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}
function deleteFleetSuccess(): FleetActionModel.DeleteFleet {
    return {
        type: ActionTypes.FLEET.DELETE_FLEET
    };
}
function deleteCarFromFleetSuccess(): FleetActionModel.DeleteCarFromFleet {
    return {
        type: ActionTypes.FLEET.DELETE_CAR_FROM_FLEET
    };
}

function updateFleetCarsSuccess(updatedFleetResponse: FleetModule.Types.UserFleetResponse): FleetActionModel.UpdateFleetCars {
    return {
        type: ActionTypes.FLEET.UPDATE_FLEET_CARS,
        payload: {
            updatedFleet: updatedFleetResponse.fleets
        }
    };
}

function getUsersFleetSuccess(userFleetsResponse: FleetModule.Types.UserFleetsResponse): FleetActionModel.GetUserFleet {
    return {
        type: ActionTypes.FLEET.GET_USER_FLEET,
        payload: {
            userFleetsResponse
        }
    };
}

function getUsersFleetFilteredSuccess(userFleetsResponse: FleetModule.Types.UserFleetsResponse): FleetActionModel.GetUserFleetFiltered {
    return {
        type: ActionTypes.FLEET.GET_USER_FLEET_FILTERED,
        payload: {
            userFleetsResponse
        }
    };
}

function setParams(params: URLSearchParams) {
    return {
        type: ActionTypes.FLEET.SET_PARAMS,
        payload: {
            params
        }
    }
}

function createFleetSuccess(): FleetActionModel.CreateFleet {
    return {
        type: ActionTypes.FLEET.CREATE_FLEET
    };
}
function resetFleetCars(): FleetActionModel.ResetFleetCars {
    return {
        type: ActionTypes.FLEET.RESET_FLEET_CARS
    };
}
function cacheFormValues(cachedChangedValues: Partial<IManageFleetFormValues>) {
    return {
        type: ActionTypes.FLEET.CACHE_FORM_VALUES,
      payload: {
          cachedChangedValues
      }
    };
}
function resetCacheFormValues(): FleetActionModel.CacheFormValues {
    return {
        type: ActionTypes.FLEET.CACHE_FORM_VALUES,
        payload: {
            cachedChangedValues: null
        }
    };
}

export {
  createFleet,
  getUsersFleet,
  resetFleetFilteredData,
  updateFleet,
  deleteCarFromFleet,
  deleteFleet,
  manageFleetCars,
  resetFleetCars,
  setActiveFleet,
  getFleetById,
  setActiveRowId,
  cacheFormValues,
  resetCacheFormValues
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/FleetActions.ts